import { Link } from 'react-router-dom';
import './ProductCard.css';

export default function ProductCard({ icon, name, category, desc, badge, catalogRoute }) {
  return (
    <div className="pcard">
      {badge && <span className="pcard__badge">{badge}</span>}
      <div className="pcard__icon">{icon}</div>
      <span className="pcard__cat">{category}</span>
      <h3 className="pcard__name">{name}</h3>
      <p className="pcard__desc">{desc}</p>
      <div className="pcard__links">
        {catalogRoute && (
          <Link to={catalogRoute} className="pcard__link pcard__link--catalog">
            View Catalog &rarr;
          </Link>
        )}
        <a href="/#contact" className="pcard__link">Request Quote &rarr;</a>
      </div>
    </div>
  );
}
